/**
 * Component to enrich experiences with media before passing them down
 */

import React from 'react';
import { ChatExperience } from '@/types/chatTypes';
import { ExperienceCard } from '@/constants/chatScreenData';
import { useEnrichedExperiences } from '@/hooks/useEnrichedExperiences';

export interface EnrichedExperiencesProviderProps {
  rawExperiences: ChatExperience[] | undefined | null;
  children: (enrichedExperiences: ExperienceCard[]) => React.ReactNode;
}

/**
 * Component that enriches experiences with media and provides them via render prop
 */
export const EnrichedExperiencesProvider: React.FC<
  EnrichedExperiencesProviderProps
> = ({ rawExperiences, children }) => {
  const enrichedExperiences = useEnrichedExperiences(rawExperiences);
  return <>{children(enrichedExperiences)}</>;
};
